import { Component } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import PagerDutyType from "../../../../types/integration/IntegrationType";

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";
import List from "./List";
import Detail from "./Detail";


interface PagerDutyProps {
    toggleMenu: Function,
    isAdmin: boolean
}

interface PagerDutyState {
    loading: number,
    pagerDuty: PagerDutyType[],
}

const initialState = {
    loading: DATA_INITIALISING,
    pagerDuty: []
}

class PagerDuty extends Component<PagerDutyProps, PagerDutyState> {
    static propTypes: { toggleMenu: PropTypes.Validator<(...args: any[]) => any>, isAdmin: PropTypes.Validator<boolean>; };

    constructor(props: PagerDutyProps) {
        super(props);

        this.state = initialState;
    };

    async getData() {
        const pagerDuty = await IntegrationsApi.getNotificationIntegrationData('pagerduty');
        this.setState({
            loading: DATA_LOADED,
            pagerDuty
        });
    }

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, pagerDuty } = this.state;

        return (
            <div id="content">
                <Helmet>
                    <title>PagerDuty - Settings - DBmarlin</title>
                    <meta name="description" content="Manage PagerDuty"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="PagerDuty">
                        <Link to="/admin">Settings</Link>
                        <Link to="/admin/integrations">Integrations</Link>
                        <span>PagerDuty</span>
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                  />
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId/:profileId" element={<Detail refresh={this.refresh} pagerDuty={pagerDuty} isAdmin={this.props.isAdmin} />}/>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} pagerDuty={pagerDuty} isAdmin={this.props.isAdmin} />}/>
                        <Route path="/" element={<List loading={loading} pagerDuty={pagerDuty} refresh={this.refresh} isAdmin={this.props.isAdmin}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

PagerDuty.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default PagerDuty;
